import React from 'react';
import { endUserLicense, privacyPolicy, termsOfService } from './documents';
import '../../styles/page.css';
import './legal.css';

const LINK_PATTERN = /(https?:\/\/[^\s]+|[\w.+-]+@[\w-]+\.[\w.-]+)/g;
const TRAILING_PUNCTUATION = /[.,;:]+$/;

const slugify = (heading) =>
  heading
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

/** Turns bare URLs and email addresses in the source text into real links. */
const linkify = (text) =>
  text.split(LINK_PATTERN).map((chunk, index) => {
    if (index % 2 === 0) return chunk;

    const [trailing] = chunk.match(TRAILING_PUNCTUATION) || [''];
    const target = chunk.slice(0, chunk.length - trailing.length);
    const href = target.includes('@') ? `mailto:${target}` : target;

    return (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        <a href={href} target={href.startsWith('mailto:') ? undefined : '_blank'} rel="noreferrer">
          {target}
        </a>
        {trailing}
      </React.Fragment>
    );
  });

/**
 * The documents are stored as plain text so they can be shipped with the game
 * unchanged. Blank lines separate blocks; a block that exactly matches one of
 * the document's headings becomes a section heading, and a block containing
 * single line breaks becomes a list.
 */
function LegalDocument({ document: { headings, text } }) {
  const [titleBlock, ...blocks] = text.trim().split(/\n{2,}/);
  const [title, updated] = titleBlock.split('\n');
  const headingSet = new Set(headings);

  return (
    <div className="page">
      <div className="shell legal">
        <header className="page__head">
          <span className="eyebrow">Legal</span>
          <h1 className="page__title">{title}</h1>
          <p className="page__sub">{updated}</p>
        </header>

        <div className="page__body legal__body">
          <nav className="legal__toc" aria-label="On this page">
            <h2>On this page</h2>
            <ul>
              {headings.map((heading) => (
                <li key={heading}>
                  <a href={`#${slugify(heading)}`}>{heading}</a>
                </li>
              ))}
            </ul>
          </nav>

          <article className="legal__document">
            {blocks.map((block, index) => {
              if (headingSet.has(block)) {
                return (
                  <h2 key={block} id={slugify(block)}>
                    {block}
                  </h2>
                );
              }

              if (block.includes('\n')) {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <ul key={index}>
                    {block.split('\n').map((line) => (
                      <li key={line}>{linkify(line)}</li>
                    ))}
                  </ul>
                );
              }

              // eslint-disable-next-line react/no-array-index-key
              return <p key={index}>{linkify(block)}</p>;
            })}
          </article>
        </div>
      </div>
    </div>
  );
}

export function Privacy() {
  return <LegalDocument document={privacyPolicy} />;
}

export function Terms() {
  return <LegalDocument document={termsOfService} />;
}

export function Eula() {
  return <LegalDocument document={endUserLicense} />;
}
